import type { ParticipateDropdownData } from 'components/ParticipateDropdown/types/ParticipateDropdownData';
import type { I18nLocale } from 'i18n/types/I18nLocale';

import { participateDropdownDataEs } from './participateDropdownData.es';

export const participateDropdownDataByLocale: Record<
  I18nLocale.ES,
  ParticipateDropdownData
> = {
  es: participateDropdownDataEs,
};
